import { Routes, Route } from "react-router-dom";
import appConfig from "../../config/appConfig";

import TierCheckout from "./TierCheckout";
import PlanCheckout from "./PlanCheckout";
import CheckoutReturn from "./CheckoutReturn";
import CheckoutCancel from "./CheckoutCancel";

const CheckoutRouter = () => (
    <Routes>
        <Route path="/tier/:code"                         element={<TierCheckout pageTitle={appConfig.pageTitle("Checkout")} />} />
        <Route path="/plan/:productCode/:planCode"        element={<PlanCheckout pageTitle={appConfig.pageTitle("Checkout")} />} />
        {/* New short-form route: /checkout/:code (e.g. /checkout/basic, /checkout/pro).
            Reuses TierCheckout — same component, just a cleaner URL for affiliate links. */}
        <Route path="/:code"                              element={<TierCheckout pageTitle={appConfig.pageTitle("Checkout")} />} />
        <Route path="/return"                             element={<CheckoutReturn pageTitle={appConfig.pageTitle("Order received")} />} />
        <Route path="/cancel"                             element={<CheckoutCancel pageTitle={appConfig.pageTitle("Checkout cancelled")} />} />
    </Routes>
);

export default CheckoutRouter;
